import { type Assignable, isUser, type User } from '../../../shared/domain/schedule/assignee.no-deps'
import type { TeamWithCount } from '../../domain/teams'
import type { UserTeam } from '../../domain/users/types.no-deps'

/**
 * Make user selection disabled if any of user's team is already selected.
 * the membership data can come in different formats so both are tried
 */
export function isUserMemberOfASelectedTeam(item: Assignable, selectedTeams: TeamWithCount[]): boolean {
    if (isUser(item)) {
        return item.teams
            ? doesUserHaveMembershipOfASelectedTeam(item, selectedTeams)
            : isUserInOneOfTheTeamMembershipField(selectedTeams, item)
    }
    return false
}

function isUserInOneOfTheTeamMembershipField(selectedTeams: TeamWithCount[], item: User) {
    return selectedTeams.some((team) => team.members?.includes(item.userId))
}

function doesUserHaveMembershipOfASelectedTeam(item: User, selectedTeams: TeamWithCount[]) {
    const userTeamIds = getUserTeamIds(item)
    return selectedTeams.map(({ id }) => id).some((id) => userTeamIds.includes(id))
}

function getUserTeamIds(item: User) {
    return item.teams.map((team: UserTeam) => team.id)
}
